import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { selector as commonSelector } from '@store/common';
import { applyFilter, toggleModal, updateGranularity, updateInterval } from '@store/common/actions';
import { dodSelector, horizontalLayoutSelector, presetFidSelector } from '@store/common/selectors';

import SummaryContainer from './SummaryContainer';

const selector = createSelector<any, any>(
  commonSelector,
  presetFidSelector,
  dodSelector,
  horizontalLayoutSelector,
  (commonStore, comparisonStore, dataStore, presetFid, dodStatus, horizontalLayout) => ({
    interval: commonStore?.interval,
    filters: commonStore.appliedFilters,
    compareMode: commonStore.compareMode,
    modal: commonStore.modal,
    features: commonStore.features,
    collapseStatus: commonStore.collapseStatus,
    comparison: comparisonStore,
    data: dataStore,
    presetFid,
    dodStatus,
    horizontalLayout,
  }),
);

export default connect(selector, {
  applyFilter,
  updateInterval,
  toggleModal,
  updateGranularity,
})(SummaryContainer);
